<template>
    <div>

        <v-btn class="mx-2 custom-bold-button white--text mb-3 mt-2" color="cyan" depressed @click="addAddons = true">
            Add Addons
        </v-btn>
        <div v-if="addAddons" class="d-flex  mb-5   ">
            <v-autocomplete hide-details v-model="selectedAddons" class="mr-2" :items="filterAddOnList" dense flat
                filled placeholder="Add-On" item-color="cyan" color="cyan" solo clearable multiple return-object
                item-text="name">
                <template v-slot:no-data>
                    <v-list-item>
                        <v-list-item-title v-html="'No addon(s) Found.'"></v-list-item-title>
                    </v-list-item>
                </template>
            </v-autocomplete>
            <v-btn class="custom-bold-button white--text" small color="cyan"
                :disabled="preSelectedAddOnList?.length == 0" @click="addSelectedAddon()">
                <v-icon>mdi-plus</v-icon>
                ADD ADD-ON</v-btn>
        </div>
        <ListingTable :columnCount="6">


            <template v-slot:thead>
                <thead class="mt-5">
                    <tr>
                        <th class="simple-table-th">#</th>
                        <th class="simple-table-th">Name</th>
                        <th class="simple-table-th">Price</th>
                        <!-- <th class="simple-table-th">Duration</th> -->
                    </tr>
                </thead>

            </template>
            <template v-slot:tbody>
                <tbody class="custom-border-bottom mt-6">
                    <template v-if="addOnList?.length > 0">
                        <tr class="alternate-listing-row" v-for="(row, index) in addOnList" :key="index">
                            <td class="simple-table-td">{{ index + 1 }}</td>
                            <td class="simple-table-td">{{ row?.name }}</td>
                            <td class="simple-table-td">{{ row?.price }}</td>
                            <!-- <td class="simple-table-td">
                                {{ row?.duration }}
                                {{ row?.duration_type }}</td> -->
                        </tr>
                    </template>
                    <tr v-else>
                        <td colspan="6" class="py-4">
                            <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                                <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                                Uhh... There are service addons at this moment.
                            </p>
                        </td>
                    </tr>
                </tbody>
            </template>
        </ListingTable>

    </div>
</template>
<script>
import { GET, POST } from "@/core/services/store/request.module";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
export default {
    data() {
        return {
            addOnList: [],
            optionAddOnList: [],
            service_id: null,
            addAddons: false,
        };
    },
    props: {
        slot_type: {
            type: String,
            default: null,
        },
    },
    components: {
        ListingTable,
    },
    computed: {
        filterAddOnList() {
            return this.optionAddOnList.filter(addOn =>
                !this.addOnList?.some(selectedAddOn =>
                    selectedAddOn?.add_on_id == addOn.id
                ));
        }
    },
    methods: {
        getServiceAddon() {
            const _this = this;
            _this.pageLoading = true;
            _this.$store
                .dispatch(GET, {
                    url: "get-service-addon/" + _this.service_id,
                })
                .then(({ data }) => {
                    _this.addOnList = data?.ServiceAddons;
                    _this.optionAddOnList = data?.optionAddOnList;
                })
                .catch((error) => {
                    _this.logError(error);
                })
                .finally(() => {
                    _this.pageLoading = false;
                });
        },
        addSelectedAddon() {
            const _this = this;
            _this.$store
                .dispatch(POST, {
                    url: "add-addons/" + _this.service_id, data: {
                        selectedAddons: _this.selectedAddons || null,
                    },
                })
                .then(() => {
                    this.getServiceAddon();
                    _this.selectedAddons = null;
                })
                .catch((error) => {
                    _this.logError(error);
                });
        },

    },
    mounted() {
        this.service_id = this.$route.params?.id;
        this.getServiceAddon();
    },
};
</script>
